import { ControlType } from '@app/core/Enum';
import { GroupListModel, SideListModel } from '@app/core/Models';
import { Guid } from 'guid-typescript';

export class HeaderModel {
  id: Guid;
  name: string;
  controlType: ControlType;
  value: Array<SideListModel>;
  groupValue: Array<GroupListModel>;
}

export class PermissionModel {
  data: string;
  componentName: any;
}
